import {PopupForm} from '../modules/PopupForm';

var regAuth = function(){
	var obj = {};

    obj.isAuth = APP.vars.isUserAuth; /* TODO много где используется это свойство */

	if(!APP.vars.isUserAuth) {
		obj.regForm = new PopupForm({
			ajax: APP.vars.isDev ? '/_src/layouts/popupFormModule/reg/' : '/service/popup/register/',
			name: 'reg',
			//wrapper: document.querySelector('[data-popupForm="reg"]'),
			onsuccess: function (data) {
				uPopup.closeAll();
				uPopup({
					content: data.message
				});
			}
		});
		obj.authForm = new PopupForm({
            ajax: APP.vars.isDev ? '/_src/layouts/popupFormModule/auth/' : '/service/popup/auth/',
            name: 'auth',
			//wrapper: document.querySelector('[data-popupForm="auth"]')
		});
		obj.recoverForm = new PopupForm({
            ajax: APP.vars.isDev ? '/_src/layouts/popupFormModule/recover/' : '/service/popup/recovery/',
            name: 'recover',
			//wrapper: document.querySelector('[data-popupForm="recover"]'),
			onsuccess: function (data) {
				uPopup({
					content: data.message,
					oncloseBefore: function () {
						uPopup.closeAll();
						obj.authForm.showPopup();
						return true;
					}
				});
			}
		});
	}
	//else localStorage.everLogin = 'login';

	return obj;
};

export {regAuth};

































